
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center mb-6">
        <span className="text-4xl">🤖</span>
      </div>
      
      <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
      
      <p className="text-xl text-muted-foreground mb-8 text-center max-w-md">
        Sorry, the page you're looking for doesn't exist or has been moved.
      </p>
      
      <Button asChild size="lg">
        <Link to="/" className="flex items-center gap-2">
          <ChevronLeft size={20} />
          Back to Home
        </Link>
      </Button>
    </div>
  );
};

export default NotFound;
